import { newLogger } from "@/utils/util";
import StoreCore from "@/store/StoreCore";

let logger = newLogger("AssociationStore");

const urls = {
  association: "/ralloc/association",
  associationWithId: (projectType, projectId) =>
    `/ralloc/association/${encodeURIComponent(
      projectType
    )}/${encodeURIComponent(projectId)}`,
  user: "/ralloc/association/user",
  utilization: "/ralloc/association/utilization",
  utilizationForProjects: `/ralloc/association`,
};

const initState = () => {
  return {
    associations: [],
    projectUtilizations: [],
    associationsByUsers: [],
    utilization: {},
  };
};

const storeCore = new StoreCore();
const actions = {
  getAssociations: async function ({ commit, dispatch }, force) {
    try {
      let data = await this.remoteRequest(
        "get",
        urls.association,
        null,
        true,
        dispatch,
        "association.get.flair|Asszociációk betöltése",
        undefined,
        force
      );
      commit("setAssociations", { data });
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
    }
  }.bind(storeCore),
  getAssociationsForProject: async function (
    { commit, dispatch },
    { projectId, projectType, from, to }
  ) {
    try {
      const searchParams = new URLSearchParams();
      searchParams.append("from", from);
      searchParams.append("to", to);
      let data = await this.remoteRequest(
        "get",
        urls.associationWithId(projectType, projectId) +
          "?" +
          searchParams.toString(),
        searchParams,
        false,
        dispatch,
        "association.get.flair|Asszociációk betöltése",
        undefined
      );
      commit("setAssociations", { data, projectId });
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
    }
  }.bind(storeCore),
  getUtilization: async function ({ commit, dispatch }, { from, to, force }) {
    try {
      const urlSearchParams = new URLSearchParams();
      urlSearchParams.append("from", from);
      urlSearchParams.append("to", to);
      let data = await this.remoteRequest(
        "get",
        `${urls.utilization}?${urlSearchParams.toString()}`,
        null,
        true,
        dispatch,
        "association.get.flair|Utilizáció betöltése",
        undefined,
        force
      );
      commit("setUtilization", data);
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
    }
  }.bind(storeCore),
  getUtilizationForProjects: async function (
    { commit, dispatch },
    { projects, from, to, force }
  ) {
    try {
      const searchParams = new URLSearchParams();
      searchParams.append("from", from);
      searchParams.append("to", to);
      for (let projectId of projects) {
        searchParams.append("p", projectId);
      }
      let data = await this.remoteRequest(
        "get",
        urls.utilizationForProjects + "?" + searchParams.toString(),
        null,
        true,
        dispatch,
        "association.get.flair|Utilizációk betöltése",
        undefined,
        force
      );
      commit("setProjectUtilizations", data);
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
    }
  }.bind(storeCore),
  getAssociationCsv: async function ({ commit, dispatch }) {
    try {
      let data = await this.remoteRequest(
        "get",
        urls.association + "/export",
        null,
        true,
        dispatch,
        "association.get.flair|Asszociációk letöltése"
      );
      commit("exportCsv", data);
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
    }
  }.bind(storeCore),
  uploadFile: async function ({ dispatch }, formData) {
    await this.remoteRequest(
      "post",
      urls.association + "/upload",
      formData,
      false,
      dispatch,
      "association.import.flair|Asszociációk importálása"
    );
  }.bind(storeCore),
  deleteAssociation: async function ({ dispatch }, id) {
    try {
      await this.remoteRequest(
        "delete",
        urls.association + `/${encodeURIComponent(id)}`,
        null,
        false,
        dispatch,
        "association.delete.flair|Asszociáció törlése",
        undefined,
        undefined,
        false,
        true,
        {
          progress:
            "association.delete.progress|Asszociáció törlése folyamatban...",
          fail: "association.delete.fail|Asszociáció törlése sikertelen!",
          success: "association.delete.success|Asszociáció törlése sikeres!",
        }
      );
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
      await Promise.reject(err);
    }
  }.bind(storeCore),
  updateAssociation: async function ({ dispatch }, request) {
    try {
      await this.remoteRequest(
        "post",
        urls.utilization,
        request,
        false,
        dispatch,
        "association.modify.flair|Asszociáció módosítása",
        undefined,
        undefined,
        false,
        true,
        {
          progress:
            "association.modify.progress|Asszociáció módosítása folyamatban...",
          fail: "association.modify.fail|Asszociáció módosítása sikertelen!",
          success: "association.modify.success|Asszociáció módosítása sikeres!",
        }
      );
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
      await Promise.reject(err);
    }
  }.bind(storeCore),
  createAssociation: async function ({ dispatch }, request) {
    try {
      await this.remoteRequest(
        "post",
        urls.association,
        request,
        false,
        dispatch,
        "association.create.flair|Asszociáció létrehozása",
        undefined,
        undefined,
        false,
        true,
        {
          progress:
            "association.create.progress|Asszociáció létrehozása folyamatban...",
          fail: "association.create.fail|Asszociáció létrehozása sikertelen!",
          success:
            "association.create.success|Asszociáció létrehozása sikeres!",
        }
      );
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
      await Promise.reject(err);
    }
  }.bind(storeCore),
  getMine: async function ({ commit, dispatch }, { from, to }) {
    try {
      const urlSearchParams = new URLSearchParams();
      urlSearchParams.append("from", from);
      urlSearchParams.append("to", to);
      let data = await this.remoteRequest(
        "get",
        urls.user + `/my-associations?${urlSearchParams.toString()}`,
        null,
        true,
        dispatch,
        "association.get.flair|Asszociációk betöltése",
        undefined
      );
      commit("setAssociations", { data });
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
    }
  }.bind(storeCore),
  getForUser: async function ({ commit, dispatch }, { employeeId, from, to }) {
    try {
      const urlSearchParams = new URLSearchParams();
      urlSearchParams.append("from", from);
      urlSearchParams.append("to", to);
      let data = await this.remoteRequest(
        "get",
        urls.user +
          `/${encodeURIComponent(employeeId)}?${urlSearchParams.toString()}`,
        null,
        true,
        dispatch,
        "association.get.flair|Asszociációk betöltése",
        undefined
      );
      commit("setAssociations", { data });
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
    }
  }.bind(storeCore),
  getForUsers: async function ({ commit, dispatch }, request) {
    try {
      let data = await this.remoteRequest(
        "post",
        urls.user,
        request,
        false,
        dispatch,
        "association.get.flairs|Asszociációk lekérése"
      );
      commit("setAssociationsByUsers", data);
    } catch (err) {
      if ("Cached!" !== err) {
        logger.error(err);
      }
      await Promise.reject(err);
    }
  }.bind(storeCore),
  clearCache: async function ({}) {
    this.clearCoreCache();
  }.bind(storeCore),
};

const mutations = {
  setAssociations: (state, { data, projectId }) => {
    state.associations = data;
  },
  setAssociationsByUsers: (state, associationsByUsers) => {
    state.associationsByUsers = associationsByUsers;
  },
  setUtilization: (state, data) => {
    state.utilization = data;
  },
  setProjectUtilizations: (state, data) => {
    state.projectUtilizations = data;
  },
  exportCsv: (state, data) => {
    const url = window.URL.createObjectURL(new Blob([data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "ralloc.csv");
    document.body.appendChild(link);
    link.click();
    link.remove();
  },
};

const getters = {
  associations: (state) => {
    return state.associations;
  },
  associationsByUsers: (state) => {
    return state.associationsByUsers;
  },
  utilization: (state) => {
    return state.utilization;
  },
  projectUtilizations: (state) => {
    return state.projectUtilizations;
  },
};

export default {
  namespaced: true,
  state: initState(),
  mutations: mutations,
  actions: actions,
  getters: getters,
};
